import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientWalkOrder, ClientWalkOrderPossibleDays, clientWalkOrderValues } from 'src/app/Interfaces/reports';
import { dayToHebrewDay } from 'src/app/Utility/functions';

@Component({
	selector: 'app-dialog',
	// templateUrl: './dialog.component.html',
	template: `
		<form [formGroup]="form" (ngSubmit)="onFormSubmit()" dir="rtl">
			<div mat-dialog-content style="overflow: initial">
				<h2>{{ title }}</h2>
				<mat-form-field class="example-full-width override-bidi" appearance="fill" style="width: 100%">
					<mat-label>תדירות</mat-label>
					<mat-select formControlName="dayValue">
						<mat-option *ngFor="let day of selectValues" [value]="day.value">
							<b>{{ day.value }}</b> - {{ day.text }}
						</mat-option>
					</mat-select>
					<mat-error>{{ getErrorMessage('dayValue') }}</mat-error>
				</mat-form-field>
				<mat-form-field class="example-full-width override-bidi" appearance="fill" style="width: 100%">
					<mat-label>סדר הליכה</mat-label>
					<input type="text" matInput formControlName="walkOrder" [placeholder]="existingWalkOrder" />
					<mat-error>{{ getErrorMessage('walkOrder') }}</mat-error>
				</mat-form-field>
				<div mat-dialog-actions>
					<button mat-button matDialogClose="cancel">ביטול</button>
					<button mat-button [mat-dialog-close]="form.value" [disabled]="form.invalid" type="submit">אישור</button>
				</div>
			</div>
		</form>
	`,
	// styleUrls: ['./dialog.component.scss'],
	styles: [],
})
export class ClientWalkDialogComponent implements OnInit {
	private dialogRef = inject(MatDialogRef<ClientWalkDialogComponent>);
	private _fb = inject(FormBuilder);

	constructor(@Inject(MAT_DIALOG_DATA) public data: { day: ClientWalkOrderPossibleDays; row: ClientWalkOrder }) {}

	form = this._fb.nonNullable.group({
		dayValue: ['', [Validators.pattern('^\\d{1,2}$'), Validators.max(12)]],
		walkOrder: ['', [Validators.pattern('^\\d{1,3}$')]],
	});

	title = '';

	selectValues = clientWalkOrderValues;

	existingWalkOrder = this.data.row?.WalkOrder || '';

	ngOnInit(): void {
		if (this.data.row) {
			this.form.patchValue({
				dayValue: this.data.row[this.data.day],
			});
		}
		this.title = `${this.data.row.ClientID} - ${this.data.row.ClientName} - ${dayToHebrewDay(this.data.day)}`;
	}

	onFormSubmit() {
		const { dayValue, walkOrder } = this.form.controls;
		const output = {};
		if (dayValue.valid || !dayValue.value) {
			output['dayValue'] = dayValue.value || '0';
		}
		if (walkOrder.valid || !walkOrder.value) {
			output['walkOrder'] = walkOrder.value || '0';
		}
		if (!walkOrder.touched && !walkOrder.value) {
			output['walkOrder'] = this.existingWalkOrder;
		}
		this.dialogRef.close(output);
	}

	getErrorMessage(control: 'dayValue' | 'walkOrder') {
		if (control === 'dayValue') {
			if (this.form.controls.dayValue.hasError('pattern') || this.form.controls.dayValue.hasError('max')) {
				return 'ערך חייב להיות מספר בין 1 ל-12';
			}
		}

		if (control === 'walkOrder') {
			if (this.form.controls.walkOrder.hasError('pattern')) {
				return 'ניתן להקליד עד 3 ספרות';
			}
		}

		return 'שדה חובה';
	}
}
